import { Loader } from '@mantine/core';
import ProductCard from '../ProductCard';
import type { ProductCardResponse } from '../../types';
import { Button, RefetchButton } from '@shared/ui';
import styles from './ProductList.module.css';
import { IoAdd } from 'react-icons/io5';
interface ProductListProps {
    products: ProductCardResponse[];
    isSelectionMode?: boolean;
    selectedProductIds?: Set<number>;
    onSelect?: (productId: number, selected: boolean) => void;
    isLoading?: boolean;
    error?: Error | null;
    refetch?: () => void;
    searchQuery?: string;
    onCreateProduct?: () => void;
    hideMenu?: boolean;
    emptyMessage?: string;
    onEdit?: (productId: number) => void;
    /** Без точек самовывоза создать товар нельзя — отключаем пустое состояние */
    isCreateProductDisabled?: boolean;
    /** Пока грузится контекст (точки самовывоза), для aria «Загрузка…» */
    isCreateProductBusy?: boolean;
}

export default function ProductList({
    products,
    isSelectionMode = false,
    selectedProductIds = new Set(),
    onSelect,
    isLoading = false,
    error,
    refetch,
    searchQuery = '',
    onCreateProduct,
    hideMenu = false,
    emptyMessage,
    onEdit,
    isCreateProductDisabled = false,
    isCreateProductBusy = false,
}: ProductListProps) {


    if (isLoading) {
        return (
            <div className={styles.loadingState}>
                <Loader />
            </div>
        );
    }

    if (error && refetch) {
        return (
            <div className={styles.loadingState}>
                <RefetchButton
                    refetch={refetch}
                    isLoading={isLoading}
                />
            </div>
        );
    }

    if (products.length === 0) {
        return (
            <div className={styles.emptyState}>
                <p>
                    {emptyMessage || (searchQuery.trim()
                        ? 'Товары не найдены по вашему запросу'
                        : 'Товары не найдены')}
                </p>
                {!searchQuery.trim() && onCreateProduct && (
                    <Button
                        variant="icon"
                        onClick={onCreateProduct}
                        disabled={isCreateProductDisabled}
                        aria-label={
                            isCreateProductBusy
                                ? 'Загрузка…'
                                : isCreateProductDisabled
                                  ? 'Сначала добавьте точку самовывоза'
                                  : 'Создать товар'
                        }
                    >
                        <IoAdd />
                    </Button>
                )}
            </div>
        );
    }
    return (
        <div className={styles.cardsGrid}>
            {products.map((product) => (
                <ProductCard
                    key={product.id}
                    product={product}
                    isSelectionMode={isSelectionMode}
                    isSelected={selectedProductIds.has(product.id)}
                    onSelect={onSelect}
                    hideMenu={hideMenu}
                    onEdit={onEdit}
                />
            ))}
        </div>
    );
}

